import React, { useState, useEffect } from "react";
import "./HeroStyles.css";
import HeroImg from "../../Images/Group 1.png";
import ParticlesBackground from "../Particles/ParticlesBackground";
import { IconWrapper, IconLink } from "../Navbar/NavbarStyles";
import { SiGithub } from "react-icons/si";
import { FaLinkedin, FaTwitterSquare, FaFacebookSquare } from "react-icons/fa";
import { VscLink } from "react-icons/vsc";
import { FiInstagram } from "react-icons/fi";
import { IoIosArrowUp } from "react-icons/io";
import Slide from "react-reveal/Slide";
import Zoom from "react-reveal/Zoom";

function Hero() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="hero">
      <ParticlesBackground />
      <Slide bottom>
        <div className="hero__left">
          <h1 className="hero__heading">
            Hello, I am Nobert welcome to my portfolio
            <span className="bolder">.</span>
          </h1>
          <div className="hero__content">
            <h3 className="hero__subheading">
              I am a <span className="bolder">frontend web developer</span> and{" "}
              <span className="bolder"> UI/UX Designer</span>
            </h3>
            <p className="hero__text">
              Passionate and curiosity driven software developer with an eye in
              design and web development.
            </p>
          </div>
        </div>
      </Slide>

      <div className="hero__right">
        <Zoom right>
          <img src={HeroImg} alt="Hero pic" srcset="" />
        </Zoom>
        <div className="social__icons">
          <a
            rel="noreferrer"
            href="https://github.com/NOBERT167"
            target="_blank"
          >
            <SiGithub />
          </a>
          <a
            rel="noreferrer"
            href="https://www.linkedin.com/mwlite/in/langat-kipkoech-nobert-ab44661ba"
            target="_blank"
          >
            <FaLinkedin />
          </a>
          <a
            rel="noreferrer"
            href="https://twitter.com/Darkcode1999"
            target="_blank"
          >
            <FaTwitterSquare />
          </a>
          <a
            rel="noreferrer"
            href="https://www.instagram.com/nobert.dev/"
            target="_blank"
          >
            <FiInstagram />
          </a>
          <a
            rel="noreferrer"
            href="https://www.facebook.com/nobert.langat.12"
            target="_blank"
          >
            <FaFacebookSquare />
          </a>
          <a rel="noreferrer" href="https://bio.link/nobertdev" target="_blank">
            <VscLink />
          </a>
        </div>
      </div>
      {showButton && (
        <div className="scroll__top" onClick={scrollToTop}>
          <IoIosArrowUp fontSize="2rem" />
        </div>
      )}
    </div>
  );
}

export default Hero;
